import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'
import Vue from 'vue'
import Router from 'vue-router'

export default {
    async changeIsLoggedIn({ commit }) {
        if(JSON.parse(localStorage.getItem('userData'))) commit("setIsLoggedIn", true)
        else commit("setIsLoggedIn", false)
    },
    // commit the synchron mutations setLanguage with the given language string.
    async fetchI18nMessages({ commit }, lang) {
        const response = await api.getLanguageConstants(lang)
        i18n.locale = lang
        commit('setI18nMessages', response)  
        return response                
    },
    // async fetchI18nMessages({ commit, state }, lang = i18n.locale) {
    //     if(JSON.parse(localStorage.getItem('userData')) === null) {
    //     // if(Vue.$route.name === 'Login') {
    //     //     var userLang = navigator.language || navigator.userLanguage
    //     //     let defaultMessages = state.loginTranslations[userLang]
    //     //     commit('setI18nMessages', defaultMessages)
    //         commit('setI18nMessages', {})
    //     } else {
    //         if(lang !== i18n.locale || Object.keys(i18n.messages).length === 0) {
    //             let messages = JSON.parse(localStorage.getItem('userData'))['languageConstans'][lang]            
    //             i18n.locale = lang
    //             commit('setI18nMessages', messages)     
    //         }
    //     }        
    // },
    doFileBulkImport({ commit, dispatch }) {
        switch(this.getters.getSelectedFileBulkImport) {
            case 'audioFilesImport':
                if(this.getters.getLabelCompanies.length > 0) {
                    let labelsDropdown = []
                    let selectedLabelCompanyId = this.getters.getSelectedLabelCompanyId
                    let labelCompany = this.getters.getLabelCompanies.find( element => element.id == selectedLabelCompanyId)
                    labelsDropdown = labelCompany.labels 
                    
                    commit('setFileBulkUploaderLabelsDropdown', labelsDropdown)
                    commit('setShowFileBulkImportDialog', true)  
                } else {
                    commit('setSnackbar', {
                        type: 'error',
                        msg:  i18n.t('lang_LABEL_TRACKS_LABEL_CHECK_ERROR')
                    })
                }
                break;
            case 'mappingImport':
                // Deselect mapping import from bulk file uploader (label tracks)
                commit('setSelectedFileBulkImport', [])

                commit('setSelectedFileImport', 'mappingImport')
                commit('setShowFileImportDialog', true)
                break;
        }
        
    },
    // General Action for File Import
    doFileImport({ commit, dispatch }) {
        if(router.currentRoute.name === "Income") {
            return
        }

        let tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') + ' fileType' + i18n.t('lang_GENERIC_CAPTION_FILE')  + '. <br />' +
                        i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
        let dialogText = ''
        let found = null
        let name = ""

        if(router.currentRoute.name === 'SalesData') {
            let identified = this.getters.getSalesDataImportOptions.find(el => 
                el.value == this.getters.getSelectedFileImport
            )
            let title = identified.text
            let extensions = identified.fileExtensions
            tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                        + ' fileType. ' +
                        i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
            dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                return {
                    fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + title + '</strong>',  
                    '<join>': "<strong>" + extensions.toUpperCase() + "</strong>"
                }[matched]
            })

        } else {
            switch(this.getters.getSelectedFileImport) {
                // Publishing > Works
                case 'alvExcelTemplateWorks':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_WORKS_BUTTON_OPTION_ALV_TEMPLATE'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                        }[matched]
                    })
                    break
                case 'suisaWorks':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_WORKS_IMPORT_SUISA'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                        }[matched]
                    })
                    break
                case 'cwr':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: 'CWR', 
                            '<join>': i18n.t('lang_PUBLISHING_WORKS_CAPTION_IMPORT_CWR_V21_V22')
                        }[matched] 
                    })
                    break
                case 'cwrJson':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_JSON'),
                            '<join>': 'JSON'
                        }[matched]
                    })
                    break
    
                // Publishing > Income
                case 'svd':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_SUBPUBLISHING_LICENSING'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                        }[matched]
                    })
                    break
                case 'gdf':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_GEMA_INCOME_FILE'), 
                            '<join>': i18n.t('lang_GENERIC_CAPTION_GDF')
                                    + ' / ' +  i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'a_tempo':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_A_TEMPO'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                        }[matched]
                    })
                    break
                case 'akm':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_AKM'), 
                            '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_CSV') 
                                      + ' / ' +  i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'aume':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_AUME'), 
                            '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_CSV')
                        }[matched]
                    })
                    break
                case 'editionbjorlund':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_EDITION_BJORLUND'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV') 
                                      + ' / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'bmgusa':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_BMG_USA'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV') 
                                      + ' / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'ctmpublishing':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_CTM'), 
                            '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'iqmusic':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_IQ_MUSIC'), 
                            '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'musicreports':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_MUSIC_REPORTS_USA'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'maestroAt':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_RUDI_SCHEDLER_MUSIC'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV')
                        }[matched]
                    })
                    break
                // case 'maestroItaly':
                //     dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                //         return {
                //             fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_RUDI_SCHEDLER_IT'), 
                //             '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                //         }[matched]
                //     })
                //     break
                // case 'maestroAtSv':
                //     dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                //         return {
                //             fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_RUDI_SCHEDLER_AT_SV'), 
                //             '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                //         }[matched]
                //     })
                //     break
                // case 'maestroCh':
                //     dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                //         return {
                //             fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_RUDI_SCHEDLER_CH'), 
                //             '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                //         }[matched]
                //     })
                //     break
                case 'roba':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType:  i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_ROBA_MUSIC'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV') 
                                      + ' / ' + i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
                case 'suisaIncome':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_SUISA'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_ZIP') + ' / F / E3 / M2'
                        }[matched]
                    })
                    break
                case 'maestroEurope':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_SCHUBERT_MUSIC'), 
                            '<join>': 'TXT / ' + i18n.t('lang_GENERAL_CAPTION_CSV') 
                                      + ' / ' +  i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
    
                // Publishing > Releases
                case 'alvExcelTemplatePublishingProjects':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_RELEASES_BUTTON_OPTION_ALV_TEMPLATE'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_EXCEL')
                        }[matched]
                    })
                    break
    
                // Publishing > Tracking
                // case 'gemaNA': 
                //     dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                //         return {
                //              fileType: i18n.t('lang_PUBLISHING_TRACKING_BUTTON_OPTION_GEMA_NA'), 
                //              '<join>': i18n.t('lang_GENERAL_CAPTION_ZIP')
                //         }[matched]
                //     })
                //     break
                // case 'setlistZip':
                //     dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                //         return {
                //              fileType: i18n.t('lang_PUBLISHING_TRACKING_SETLISTS_BUTTON_OPTION_SETLISTS_FILE'), 
                //              '<join>': i18n.t('lang_GENERAL_CAPTION_ZIP')
                //         }[matched]
                //     })
                //     break
                // case 'setlistXlsx':
                //     dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                //         return {
                //              fileType: i18n.t('lang_PUBLISHING_TRACKING_SETLISTS_BUTTON_OPTION_SETLISTS_FILE'), 
                //              '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                //         }[matched]
                //     })
                //     break
    
                // Label > Releases
                case 'harvestMedia':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_RELEASES_BUTTON_OPTION_IMPORT_ALBUMS'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV')
                        }[matched]
                    })
                    break
                case 'alvExcelTemplateLabelReleases':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_RELEASES_BUTTON_OPTION_IMPORT_ALBUMS'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                        }[matched]
                    })
                    break
                case 'alvZipLabelReleases':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_RELEASES_BUTTON_OPTION_IMPORT_ALBUMS'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                    break
    
                // Label > Sales Data
                case 'alvExcelTemplateLabelSalesData':
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: "<strong>" + name + '</strong> ' + i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_TEXT'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                        }[matched]
                    })
                    break
                case 'allegro': case 'damusic': case 'finetunes': case 'galileo':
                case 'hart': case 'naxosusa': case 'outside': case 'pias':
                case 'planet': case 'qedovaloffice': case 'roughtrade': case 'sony': case 'soulfood':
                case 'telamomusik': case 'warnermusic': case 'wordandsound': case 'universalmusicentertainment':
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + name + '</strong>', 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS')
                        }[matched]
                    })
                break
                case 'indigo':
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + name + '</strong>', 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX_XLS') + "/" + i18n.t('lang_GENERAL_CAPTION_CSV')
                        }[matched]
                    })
                break
                case 'fuga': case 'theorchard':
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + name + '</strong>', 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_ZIP')
                        }[matched]
                    })
                break
                case 'awalrecordings': case 'bandcamp': case 'brokensilence': case 'feiyr': 
                case 'kontor': case 'recordjet': case 'zebralution': case 'edel': case 'igroove' :
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + name + '</strong>',  
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV')
                        }[matched]
                    })
                break
                case 'believedigital':
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + name + '</strong>', 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV_ZIP')
                        }[matched]
                    })
                break
                case 'naxos': case 'spectre': case 'adaworldwide': case 'ygplus':
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + name + '</strong>', 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX')
                        }[matched]
                    })
                break
                case 'soulfoodbelieve':
                    found = this.getters.getSalesDataImportOptions.find(el => 
                        el.value == this.getters.getSelectedFileImport
                    )
                    name = found.text
                    tempText =  i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_WANT_TO_UPLOAD') 
                                + '<br /> fileType <br />' +
                                i18n.t('lang_GENERAL_IMPORT_DIALOG_TEXT_SELECT_FILE_TYPE')
    
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_LABEL_SALES_DATA_DIALOG_IMPORT_SALES_DATA_FILE_COPANY_TEXT') + ": <strong>" + name + '</strong>', 
                            '<join>':  i18n.t('lang_GENERAL_CAPTION_CSV_XLS')
                        }[matched]
                    })
                break
                case 'bmgus': 
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_BMG_US'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV') 
                        }[matched]
                    })
                    break
                case 'bmgde':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_PUBLISHING_INCOME_BUTTON_OPTION_BMG_DE'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_CSV') 
                        }[matched]
                    })
                    break
                // Shipping > Shipping Rows Importer
                case 'shippingRows':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_ERP_SHIPPING_CAPTION_SHIPPING_ROWS_FILE'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX')
                        }[matched]
                    })
                    break
    
                // Invoices > Invoices Rows Importer
                case 'invoiceRows':
                    dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                        return {
                            fileType: i18n.t('lang_GENERAL_CAPTION_INVOICE_ROW_FILE'), 
                            '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX')
                        }[matched]
                    })
                    break
                //AzPersons
                case 'alvExcelTemplateAzPersons' :
                dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                    return {
                        fileType: i18n.t('lang_GENERAL_CAPTION_EXCEL_TEMPLATE'), 
                        '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX')
                    }[matched]
                })
                break
                //LabelContracts
                case 'alvExcelTemplateLabelContracts' :
                dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                    return {
                        fileType: i18n.t('lang_GENERAL_CAPTION_EXCEL_TEMPLATE'), 
                        '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX')
                    }[matched]
                })
                break
                // default:
                //     return "blub"
                //     // dialogText = tempText.replace(/fileType|<join>/gi, matched => {
                //     //     return {
                //     //         fileType: i18n.t('lang_GENERAL_CAPTION_EXCEL_TEMPLATE'), 
                //     //         '<join>': i18n.t('lang_GENERAL_CAPTION_XLSX')
                //     //     }[matched]
                //     // })
                // break
    
            }
        }

        commit('setImportDialogText', dialogText)   
        commit('setShowFileImportDialog', true)      
    },

    setSelectedFileImportOption({commit}, value) {
        commit('setSelectedFileImportOption',value)
    },
    async changeCompany({ commit, dispatch, getters }, params = {context: 'overAll'}) {
        let context = params.context.charAt(0).toUpperCase() + params.context.slice(1)

        let response = {}
        if(params.context === 'overAll') response = await api.changeSelectedOverAllCompany(getters.getSelectedOverAllCompany.alvId)
        else response = await api.changeSelectedCompany(params.context, params.newId)

        if(response === undefined || response.length === 0 || response.error === 1) {
            // Sets dropdown back to the current selected company (uses value from localStorage), because it could not change the ID in DB.
            if(params.context === 'overAll') commit('setSelectedOverAllCompany')
            if(params.context === 'publishing' || params.context === 'label') commit('setSelected' + context + 'Company')

            commit('setSnackbar', { 
                    type: 'error', 
                    msg: i18n.t('lang_GENERAL_SNACKBAR_SELECTED_COMPANY_NOT_CHANGED')
                }
            )
        } else {
            // Grab localStorage data, change it to the new ID and store it back in.
            let userData = JSON.parse(localStorage.getItem('userData'))

            // ERP or settings page, where we have publishing + label company selector:
            if(params.context === 'overAll') {
                userData.selectedOverAllCompany = response
                // context 1 = Publishing Company | context 2 = Label Company
                // over all company has to be in sync with the publishing OR label side
                if(response.context === 1) {
                    userData.selectedPublishingCompanyId = response.id
                    commit('setSelectedPublishingCompanyId', response.id)
                }
                if(response.context === 2) {
                    userData.selectedLabelCompanyId = response.id
                    commit('setSelectedLabelCompanyId', response.id)
                }
            }
            if(params.context === 'publishing'){
                userData['selected'+ context + 'CompanyId'] = params.newId

                // sync the Over All Company object with the new selected publishing/label company
                let newSelectedCompanyName = getters['getPublishingCompanies'].find(company =>
                    company.id === params.newId
                ).name
                commit('setSelectedPublishingCompany', newSelectedCompanyName)
            }
            if(params.context === 'publishing' || params.context === 'label') {
                userData['selected'+ context + 'CompanyId'] = params.newId

                // sync the Over All Company object with the new selected publishing/label company
                let alvId = getters['get' + context + 'Companies'].find(company =>
                    company.id === params.newId
                ).alvId

                let newSetOverAllCompany = {
                    alvId: alvId,
                    context: params.context === 'publishing' ? 1 : 2,
                    id: params.newId
                }
                userData.selectedOverAllCompany = newSetOverAllCompany
                commit('setSelectedOverAllCompany', newSetOverAllCompany)
            }

            localStorage.setItem('userData', JSON.stringify(userData))

            // Snackbar for user, that company has changed.
            commit('setSnackbar', { 
                    type: 'success', 
                    msg: i18n.t('lang_GENERAL_SNACKBAR_CHANGED_SELECTED_COMPANY')
                }
            )            

            // fetch the entries of the new chosen company
            if(router.currentRoute.name === 'Settings') {
                if(response.context === 1) dispatch('fetchPublishingSettings')
                if(response.context === 2) dispatch('fetchLabelSettings')
            } else if(router.currentRoute.name === 'Invoices') {
                dispatch("fetchInvoices")
            }  else {
                if(router.currentRoute.name.slice(-4) !== 'Edit') {
                    dispatch('fetch' + router.currentRoute.name)
                }
            }
        }
    },

//Label > Statements
   async doFileReport({ commit, dispatch, getters }){
    let metaData = {}
    let queryParams = {}
    let response
    let DIR = ""
        switch(this.getters.getSelectedFileReport) {
            
            case'balanceReportLabelStatements' :
                DIR = "label/statements"
                queryParams = { "action": 'accountBalance' }
        
               response = await api.triggerAction(DIR, metaData, queryParams)
        
                if(response.error === -1) {
                    api.getFileFromALV(response.response.path)
                    commit('setSnackbar', {
                        type: 'success',
                        msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                    })
        
                } else {
                    commit('setSnackbar', {
                        type: 'error',
                        msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL')
                    })
                }
            break

            case'paymentListLabelStatements':
                DIR = "label/statements"
                queryParams = { "action": 'paymentList' }
        
                response = await api.triggerAction(DIR, metaData, queryParams)
        
                if(response.error === -1) {
                    api.getFileFromALV(response.response.path)
                    commit('setSnackbar', {
                        type: 'success',
                        msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                    })
        
                } else {
                    commit('setSnackbar', {
                        type: 'error',
                        msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOT_SUCCESSFULL')
                    })
                }
            break

            case 'licensorPaymentsReport':
                commit('setShowLabelStatementsLicensorPaymentsDialog', true)
            break

            case 'gemaTas2026Report':
                commit('setShowGemaTas2026Dialog', true)
            break

            case'glocStatements':
                let selectedTimeUnit = getters.getSelectedPeriodTimeUnitLabelStatements
                let selectedPeriodNumber = getters.getSelectedPeriodNumberLabelStatements
                let selectedPeriodYear = getters.getSelectedPeriodYearLabelStatements

                // check period is selected correctly, either "year,2021" or "3,month,2021"
                if (selectedTimeUnit === 'year' && (selectedPeriodYear !== '' && selectedPeriodYear !== undefined && selectedPeriodYear !== null)) {
                    var period = selectedTimeUnit + ',' + selectedPeriodYear }
                else if ((selectedTimeUnit === 'month' || selectedTimeUnit === 'quarter' || selectedTimeUnit === 'halfyear') && (
                            (selectedPeriodNumber !== '' && selectedPeriodNumber !== undefined && selectedPeriodNumber !== null) &&
                            (selectedPeriodYear !== '' && selectedPeriodYear !== undefined && selectedPeriodYear !== null) )) {
                    var period = selectedPeriodNumber + ',' + selectedTimeUnit + ',' + selectedPeriodYear
                } else {
                    var period = null
                }

                if(period !== null){
                    dispatch('createGlocStatements', {period})
                }else{
                    commit('setShowPeriodRequiredDialog', true)
                }
            break

// ERP > INVOICES
            case'accountReviewErpInvoices':
                dispatch('invoicesAccountOverview')
            break

            case'gemaAuditReportErpInvoices':
                dispatch('doGemaAuditReport')
            break
        }
    },
    
// "Run Error Lists" Functions
    // RUN
    async runErrorLists({ getters, commit, dispatch}, params) {
        let polling = null
        let context = params.context
        let queryParams = { "action" : "runErrorLists" }
        let response = await api.triggerAction(params.dir, params.metaData, queryParams)

        if(response.error === -1) {
            commit('setShowRunErrorListDialog', true)
            commit('setRunErrorListDialogText', i18n.t("lang_GENERAL_CAPTION_RUN_ERROR_LISTS_DIALOG_UPDATE_ERROR_LISTS"))

            // API call to process
            let processResult = await dispatch('processRunErrorLists', { processId: response.response.processId, context: context, polling: polling })

            if(processResult.status === 'running') {
                polling = setInterval(() => {
                    dispatch('processRunErrorLists', { processId: response.response.processId, context: context, polling: polling }) 
                }, 3000)
                
                // setTimeout(() => { clearInterval(polling) }, 180000)
            }
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },
    // PROCESS
    async processRunErrorLists({ commit, dispatch, getters }, params) {
        let result = await api.getProgressOfProcess(params.processId, params.polling).then(response => { return response })
        commit('setRunErrorListDialogProgressValue', result.percent)

        if(result.status === 'finished') {
            clearInterval(params.polling)
            commit('setRunErrorListDialogText', i18n.t("lang_GENERAL_CAPTION_RUN_ERROR_LISTS_DIALOG_ERROR_LISTS_SUCCESSFULL")) 
            dispatch('fetch' + params.context)
            if(result.error === 1) {
                commit('setRunErrorListDialogText', result.errorMsg)
            }
        }
        return result
    },
    // DOWNLOAD
    async downloadErrorLists({ commit }, params) {
        let queryParams = { "action" : "downloadErrorList"}
        let response = await api.triggerAction(params.dir, params.metaData, queryParams)

        if(response.error === -1) {
            if(response.response.path !== null) {
                api.getFileFromALV(response.response.path)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            }
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // GEMA WORK CLASSICATIONS check
    async compareGemaBew({ commit }, params) {
        let queryParams = { "action" : "compareGemaBew"}
        let response = await api.triggerAction(params.dir, params.metaData, queryParams)

        if(response.error === -1) {
            if(response.response.path !== null) {
                api.getFileFromALV(response.response.path)
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
                })
            } else { // case where filepath is null, so no file generated, e.g. GLM gdf in ALISA WESSEL account (no work is matching)
                commit('setSnackbar', {
                    type: 'error',
                    msg: i18n.t('lang_GENERIC_SNACKBAR_DOWNLOAD_NOFILE')
                })       
            }
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

// Run Statements Functions
    // RUN
    async launchStatementRun({ commit, getters }, params) {
        let context = params.context
        let selectedStatementDate = params.statementDate
        let noPdf = params.createPdf
        let c3Calculation = params.c3Calculation
        let queryParams = {}

        // format the period into a string for the API Call 
        let period = ''
        if(getters['getSelectedPeriodTimeUnit' + context] === 'year') {
            period = getters['getSelectedPeriodTimeUnit' + context]  + ',' + getters['getSelectedPeriodYear' + context]
        } else {
            period = getters['getSelectedPeriodNumber' + context] + ',' +
            getters['getSelectedPeriodTimeUnit' + context]  + ',' +
            getters['getSelectedPeriodYear' + context]
        }

        if(selectedStatementDate !== undefined &&  noPdf !== undefined){
            queryParams = { "action": "launchStatementRun", "period" : period, "statementDate" : selectedStatementDate  }
            
            if(noPdf === true){
                queryParams.generatePdf = "no" 
            }else{
                queryParams.generatePdf = "yes" 
            }

        }else{

            queryParams = { "action": "launchStatementRun", "period" : period}
        }

        if (c3Calculation !== undefined) {
            queryParams['c3Calculation'] = c3Calculation
        }

        let metaData = {
            "alvIds" : context === 'PublishingStatements'
                ? getters.getPublishingStatementsActionIds
                : getters['getSelected' + context]
        }

        if (context === 'PublishingStatements') {
            if (!metaData.alvIds.length && !getters.getPublishingStatementsActionScope) return
            Object.assign(queryParams, getters.getPublishingStatementsActionQuery)
        }

        // API call to start process
        let runStatementsResponse = await api.triggerAction(params.dir, metaData, queryParams)
        commit('setIs' + context + 'Running', true)

        if(runStatementsResponse.error === -1) {
            // commit('setIs' + context + 'Running', true)

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_STATEMENTS_RUNNING'),
                // timeout: -1
            })
        } else {
            let errorMsg = i18n.t(runStatementsResponse.errorMsg)
            console.log(runStatementsResponse)
            
            if (runStatementsResponse.dialogParameters) {
                errorMsg = this._vm.$alvPlugin.buildParameterizedMessage(runStatementsResponse.errorMsg, runStatementsResponse.dialogParameters)
            }
            commit('setIs' + context + 'Running', false)
            commit('setSnackbar', { 
                type: 'error', 
                msg: errorMsg
            })
        }
    },
    // CHECK STATUS
    async checkStatusOfStatementsRun({ getters, commit, dispatch}, params) {
        let response = await api.getStatusOfStatementsRun(params.dir)
        let context = params.context
        if(response.error === -1) {
            if(response.status === 'running') {
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t(response.txt) +  ' ' + response.percent + '%'
                })
            }

            if(response.status === 'finished') {
                commit('setSnackbar', {
                    type: 'success',
                    msg: i18n.t('lang_GENERIC_SNACKBAR_STATEMENTS_DONE')
                })

                commit('setIs' + context + 'Running', false)
                dispatch('fetch' + context)
                commit('setIsAllSelected' + context, false)
                commit('setSelected' + context, [])
                commit('setSelected' + context + 'Action', [])
                commit('setSelectedPeriodValues', {
                    number: null,
                    timeUnit: null,
                    year: null
                })
            }
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: response.errorMsg
            })
        }
    },

    // REGIONS
    async fetchAutocompleteRegionDialogInclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setRegionDialogIncludeOptions', items)
    },
    async fetchAutocompleteRegionDialogExclude({ commit }, input) {
        let items = await api.getRegion(input, i18n.locale)
        commit('setRegionDialogExcludeOptions', items)
    },

    // MANAGE TAGS
    async manageTags({ commit, getters }, params) {
        let selected = getters['getSelected' + params.context]
        let addTag = getters.getAddTag
        let removeTag = getters.getRemoveTag

        let metaData = {     
            // TODO: "[params.ids]" is not needed anymore, we will always name "alvIds" from now on!
            [params.ids] : selected,
            "tags" : { "add" : addTag, "remove" : removeTag }
        }
        let queryParams = { "action": "replaceTags" }

        let response = await api.triggerAction(params.dir, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t("lang_GENERAL_SNACKBAR_MANAGE_TAGS_SUCCESSFULLY")
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },
    //SYNC DATA FROM ALV TO API
    async syncData({commit, getters}, params){
        let selected = getters['getSelected' + params.context]
        let metaData = {     
            [params.ids] : selected,
            "api": params.api
        }
        let queryParams = { "action": "syncData" }

        let response = await api.triggerAction(params.dir, metaData, queryParams)
        
        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t(response.txt)
            })

            return response.path
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },
    async fetchImporters({ commit, getters }, domain) {
        let importers = await api.getImporters(domain)
        commit('setListpageImporters', importers.list)
    },

    // Persons Panel: DELETE 
    async deleteSelectedPersonsPanelEntry({ getters, commit }) {
        let selectedPeronsId = getters.getSelectedPersonsPanelEntry
        let connectedPersons = getters.getPersonsPanelEntry
        let index = connectedPersons.findIndex(person => person.id === selectedPeronsId)

        let startAmount = connectedPersons.length
        Vue.delete(connectedPersons, index)
        let newAmount = connectedPersons.length

        if(startAmount > newAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'),
            })
        }

        commit('setSelectedPersonsPanelEntry', [])
        if(startAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
    },
    async fetchAutocompletePersonsPanelEntryPerson({ commit }, input) {
        let response = await api.getAutocompleteSearch('az/persons', input)
        commit('setPersonsPanelEntryPersonOptions', response.list)
    },

    openConfirmationDialog({commit}){
        return new Promise((resolve) => {
            // Store the resolve function in Vuex so it can be resolved later
            commit('setConfirmationDialog', {show: true, result: false, resolveCallback: resolve} )
        })
    },

    resolveConfirmationDialog({commit}){
        //Close dialog
        commit('setShowConfirmationDialog', false) 
        // Resolve the promise with true
        commit('setResolveCallbackConfirmationDialog', true)
    },

    async runConfirmationDialog({dispatch}) {
        // Open the dialog and wait for the result (true/false)
        const result = await dispatch('openConfirmationDialog')
        return result
    },

    async sendDataSharingRequest({ commit, getters }, params) {
        let domain = params.domain
        let dataSharingCode = params.dataSharingCode
        let numberOfRecords = params.numberOfRecords
        let searchTerm = params.searchTerm

        const dir = "dataSharing/sendRequest"
        
        let response = await api.triggerAction(dir, params, {})

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t("lang_GENERIC_MESSAGE_DATA_SHARING_REQUEST_SENT")
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },

    async acceptDataSharingRequest({ commit, getters }, params) {
        let requestId = params.requestId
        const dir = "dataSharing/acceptRequest"

        let response = await api.triggerAction(dir, params, {})

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t("lang_GENERIC_MESSAGE_DATA_SHARING_REQUEST_ACCEPTED")
            })
            commit('setDataSharingNotifications', response.data)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },

    async declineDataSharingRequest({ commit, getters }, params) {
        let requestId = params.requestId
        const dir = "dataSharing/declineRequest"

        let response = await api.triggerAction(dir, params, {})

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t("lang_GENERIC_MESSAGE_DATA_SHARING_REQUEST_DECLINED")
            })
            commit('setDataSharingNotifications', response.data)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },

    async dismissDataSharingNotification({ commit, getters }, params) {
        let requestId = params.requestId
        const dir = "dataSharing/dismissNotification"

        let response = await api.triggerAction(dir, params, {})

        if (response.error === -1) {
            commit('removeDataSharingNotification', requestId)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    }
}